// Extend Trix to handle underline
Trix.config.textAttributes.underline = {
    tagName: "u",
    inheritable: true,
    style: {textDecoration: "underline"},
    parser: function (element) {
        return element.style.textDecoration === "underline";
    }
};


document.addEventListener("trix-initialize", function () {
    if ($('.hud_trip_reports.new, .hud_trip_reports.edit, .hud_trip_reports.create, .hud_trip_reports.update').length === 0) {
        return false
    }

    document.querySelectorAll("trix-toolbar").forEach((toolbar) => {
        if (!toolbar.querySelector(".trix-button--underline")) {
            addUnderlineButton(toolbar);
        }
    });
});

function addUnderlineButton(toolbar) {
    // Create an Underline button
    const button = document.createElement("button");
    button.setAttribute("type", "button");
    button.setAttribute("class", "trix-button trix-button--icon trix-button--underline");
    button.setAttribute("data-trix-attribute", "underline");
    button.setAttribute("title", "Underline");
    button.setAttribute("data-trix-key", "u");
    button.setAttribute("tabindex", -1);

    // Find the formatting group and append the button
    const formattingGroup = toolbar.querySelector(".trix-button-group");
    if (formattingGroup) {
        formattingGroup.appendChild(button);
    }
}

handleTabEvent()

function handleTabEvent() {
    // alert(12)
    document.addEventListener("keydown", function (event) {
        if (event.key === "Tab") {
            let editorElement = document.activeElement;

            // Ensure the active element is a Trix editor
            if (editorElement.tagName === "TRIX-EDITOR") {
                event.preventDefault(); // Stop default tab behavior
                let editor = editorElement.editor; // Get Trix editor instance
                let range = editor.getSelectedRange(); // Get selected text range

                if (range[0] === range[1]) {
                    // No selection: Insert 4 spaces at the cursor position
                    editor.insertString("    ");
                } else {
                    // Selection exists: Indent each line of selected text
                    let documentFragment = editor.getSelectedDocument(); // Get the selected content
                    let htmlContent = documentFragment.toString(); // Convert to plain text

                    // Add 4 spaces at the start of each line
                    let indentedText = htmlContent.replace(/^/gm, "    ");

                    // Replace the selected text with indented text
                    editor.setSelectedRange(range);
                    editor.insertString(indentedText);
                }
            }
        }
    });
}


